import { render, staticRenderFns } from "./GExamListCard.vue?vue&type=template&id=507a70cc&scoped=true&"
import script from "./GExamListCard.vue?vue&type=script&lang=ts&"
export * from "./GExamListCard.vue?vue&type=script&lang=ts&"
import style0 from "./GExamListCard.vue?vue&type=style&index=0&id=507a70cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507a70cc",
  null
  
)

export default component.exports